var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.666992V17.3337H13.8333V11.5003H10.5V5.66699C10.5 2.90557 12.7386 0.666992 15.5 0.666992ZM13.8333 2.77533C13.1417 3.16699 12.1667 4.14199 12.1667 5.66699V9.83366H13.8333V2.77533ZM5.5 10.5837V17.3337H3.83333V10.5837C1.93147 10.1976 0.5 8.51616 0.5 6.50033V1.50033H2.16667V7.33366H3.83333V1.50033H5.5V7.33366H7.16667V1.50033H8.83333V6.50033C8.83333 8.51616 7.40183 10.1976 5.5 10.5837Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyIcon);
export default __webpack_public_path__ + "static/media/readyIcon.36f3d187f434e465475d7b2f5fffc659.svg";
export { ForwardRef as ReactComponent };